import Vue from 'vue'
import App from './Index.vue'
import i18n from '../i18n'
import Buefy from 'buefy'
import VueGoogleCharts from 'vue-google-charts'

Vue.use(Buefy);
Vue.use(VueGoogleCharts);

Vue.config.productionTip = false;

new Vue({
    i18n,
    render (h) { return h(App) }
}).$mount('#app');
